var materea_t=window.materea_t||(window.materea_t=function(k,v){var d=window.materea_texte;if(!d){try{d=JSON.parse(document.getElementById('materea-i18n').textContent)}catch(e){d={}}window.materea_texte=d}var s=d[k];if(s==null)return k;return v?s.replace(/\{(\w+)\}/g,function(m,n){return n in v?v[n]:m}):s});
/* Materea Warenkorb-Skript. Erzeugt von build-theme-warenkorb.py.
   Drei Aufgaben:
   1. Die Zahl im Header stimmt nach jeder Aenderung.
   2. Nach "In den Warenkorb" faehrt die Schublade auf und zeigt, was drin liegt.
      Ausgeloest wird sie vom Ereignis materea:korb, das die Produktseite feuert.
      Sie horcht NICHT auf fetch, damit hier nichts kaputt geht, wenn die
      Kaufzone einmal anders baut.
   3. Auf /cart aendern Stepper und Entfernen den Korb ohne Neuladen.
   Ohne JavaScript bleibt alles bedienbar: die Stepper sind Submit-Knoepfe des
   Warenkorb-Formulars, Entfernen ist ein Link. */
(function () {
  'use strict';
  if (window.__materea_korb) return;
  window.__materea_korb = true;

  var schublade = document.querySelector('[data-korb-schublade]');
  var muster = (schublade && schublade.getAttribute('data-geld-muster')) || '1.234,56 €';
  var ziffern = muster.match(/[\d.,]+/);
  var geldVor = ziffern ? muster.slice(0, ziffern.index) : '';
  var geldNach = ziffern ? muster.slice(ziffern.index + ziffern[0].length) : ' €';
  var ZULAGE = (schublade && schublade.getAttribute('data-zulage-handle')) || 'toenungszulage';
  var WSTYP = ((schublade && schublade.getAttribute('data-workshop-typ')) || 'Workshop').toLowerCase();
  var FREI = !schublade || schublade.getAttribute('data-frei') === 'true';
  var GATE = (schublade && schublade.getAttribute('data-gate-preis')) || materea_t("js.korb.preis_nach_freischaltung");
  var TITEL_NEU = (schublade && schublade.getAttribute('data-titel-neu')) || materea_t("js.korb.in_den_warenkorb_gelegt");
  var TITEL_KORB = (schublade && schublade.getAttribute('data-titel-korb')) || materea_t("js.korb.dein_warenkorb");

  function geld(cent) {
    return geldVor + (cent / 100).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + geldNach;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c];
    });
  }
  function istWs(z) { return String(z.product_type || '').toLowerCase() === WSTYP; }
  function istZulage(z) { return String(z.handle || '') === ZULAGE; }

  /* ---------- Header ---------- */
  function kopfZahl(korb) {
    var link = document.querySelector('.site-korb');
    if (!link) return;
    var zahl = link.querySelector('[data-korb-zahl]');
    /* Positionen, nicht Stueck: die Zulage haengt an ihrem Material. */
    var n = (korb.items || []).filter(function (z) { return !istZulage(z); }).length;
    if (!n && (korb.items || []).length) n = korb.items.length;
    if (zahl) zahl.textContent = n;
    link.hidden = n === 0;
  }

  /* ---------- Positionen gruppieren: Zulage unter ihr Material ---------- */
  function gruppiere(items) {
    var belegt = {};
    var raus = [];
    items.forEach(function (it) {
      if (istZulage(it)) return;
      var zul = null;
      for (var i = 0; i < items.length; i++) {
        var z = items[i];
        if (!istZulage(z) || belegt[z.key]) continue;
        var zzu = (z.properties && z.properties._zu) ? String(z.properties._zu) : '';
        var ton = z.properties && z.properties['Farbton'];
        if (zzu && zzu === String(it.variant_id)) { zul = z; }
        else if (!zzu && ton && it.properties && it.properties['Farbton'] === ton) { zul = z; }
        if (zul) { belegt[z.key] = true; break; }
      }
      raus.push({zeile: it, zulage: zul});
    });
    items.forEach(function (it) {
      if (istZulage(it) && !belegt[it.key]) raus.push({zeile: it, zulage: null});
    });
    return raus;
  }

  function meta(z) {
    var teile = [];
    if (z.variant_title && z.variant_title.indexOf('Default') < 0) teile.push(z.variant_title);
    var p = z.properties || {};
    Object.keys(p).forEach(function (k) {
      if (k.charAt(0) === '_' || !p[k]) return;
      teile.push(k + ' ' + p[k]);
    });
    return teile.join(' · ');
  }
  function preisDarf(z) { return FREI || istWs(z); }

  function karte(eintrag, neu) {
    var z = eintrag.zeile;
    var bild = z.image ? '<img src="' + esc(z.image) + '" alt="' + esc(z.product_title) + '" width="60" height="60">' : '';
    var zeilen = '';
    var betrag = preisDarf(z) ? geld(z.final_line_price) : esc(GATE);
    var menge;
    if (istWs(z)) {
      menge = '<span>' + z.quantity + ' ' + (z.quantity === 1 ? materea_t("js.korb.platz") : materea_t("js.korb.plaetze")) + '</span>';
    } else if (istZulage(z)) {
      menge = '<span>' + (z.quantity === 1 ? materea_t("js.korb.gebinde_eins") : materea_t("js.korb.gebinde_anzahl",{n:z.quantity})) + '</span>';
    } else {
      menge = '<span class="wk-step kb-step">' +
        '<button class="wk-step-btn" type="button" data-kb-minus aria-label="' + esc(z.product_title) + materea_t("js.korb.gebinde_weniger") + (z.quantity <= 1 ? ' disabled' : '') + '>&minus;</button>' +
        '<span class="kb-step-zahl">' + z.quantity + '</span>' +
        '<button class="wk-step-btn" type="button" data-kb-plus aria-label="' + esc(z.product_title) + materea_t("js.korb.gebinde_mehr");
    }
    zeilen += '<div class="kb-zeile kb-zeile-menge">' + menge + ' <b>' + betrag + '</b></div>';
    if (eintrag.zulage && preisDarf(z)) {
      zeilen += materea_t("js.korb.zulage_zeile") + geld(eintrag.zulage.final_line_price) + '</b></p>';
    }
    zeilen += '<button class="wk-link kb-weg" type="button" data-kb-weg aria-label="' + materea_t("js.korb.entfernen_label",{titel:esc(z.product_title)}) + '">' + materea_t("js.korb.entfernen") + '</button>';
    return '<div class="' + (neu ? 'kb-neu' : 'kb-pos') + '" data-kb-key="' + esc(z.key) + '" data-kb-menge="' + z.quantity + '"' +
      (eintrag.zulage ? ' data-kb-zulage="' + esc(eintrag.zulage.key) + '"' : '') + '>' +
      '<div class="kb-bild">' + bild + '</div><div>' +
      '<p class="kb-name">' + esc(z.product_title) + '</p>' +
      '<p class="kb-meta">' + esc(meta(z)) + '</p>' + zeilen +
      '</div></div>';
  }

  function fuelle(korb, neuIds) {
    if (!schublade) return;
    var titel = schublade.querySelector('[data-korb-titel]');
    if (titel) titel.textContent = neuIds ? TITEL_NEU : TITEL_KORB;
    var eintraege = gruppiere(korb.items || []);
    schublade.classList.toggle('kb-leer', !eintraege.length);
    var neu = [], rest = [];
    eintraege.forEach(function (e) {
      if (neuIds && neuIds.indexOf(String(e.zeile.variant_id)) >= 0) neu.push(e); else rest.push(e);
    });
    if (!neuIds) { rest = neu.concat(rest); neu = []; }
    else if (!neu.length && rest.length) { neu = [rest.shift()]; }

    var anz = schublade.querySelector('[data-korb-anzahl]');
    if (anz) anz.textContent = eintraege.length + (eintraege.length === 1 ? materea_t("js.korb.position") : materea_t("js.korb.positionen"));
    var body = schublade.querySelector('[data-korb-body]');
    if (body) {
      var html = neu.map(function (e) { return karte(e, true); }).join('');
      if (rest.length) {
        if (neu.length) html += materea_t("js.korb.schon_im_korb");
        html += rest.map(function (e) { return karte(e, false); }).join('');
      }
      if (!eintraege.length) html = materea_t("js.korb.leer");
      body.innerHTML = html;
    }
    var g = schublade.querySelector('[data-korb-gesamt]');
    if (g) {
      var alleFrei = FREI || !(korb.items || []).some(function (z) { return !istWs(z); });
      g.textContent = alleFrei ? geld(korb.total_price) : GATE;
      g.classList.toggle('offen', !alleFrei);
    }
    kopfZahl(korb);
  }

  var letzteNeu = null;
  function aendere(knopf) {
    var pos = knopf.closest('[data-kb-key]');
    if (!pos) return;
    var key = pos.getAttribute('data-kb-key');
    var menge = parseInt(pos.getAttribute('data-kb-menge'), 10) || 1;
    var art = knopf.hasAttribute('data-kb-plus') ? 'plus' : (knopf.hasAttribute('data-kb-minus') ? 'minus' : 'weg');
    var soll = art === 'plus' ? menge + 1 : (art === 'minus' ? menge - 1 : 0);
    if (art === 'minus' && soll < 1) return;
    var updates = {};
    updates[key] = soll;
    var zk = pos.getAttribute('data-kb-zulage');
    if (zk) updates[zk] = soll;
    pos.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
    fetch(((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||"/")+"cart/update.js", {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({updates: updates})
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).catch(function () { return hole(); }).then(function (k) {
      if (document.querySelector('[data-warenkorb]')) { window.location.reload(); return; }
      if (letzteNeu && !(k.items || []).some(function (i) { return letzteNeu.indexOf(String(i.variant_id)) >= 0; })) letzteNeu = null;
      fuelle(k, letzteNeu);
      var ziel = art === 'weg' ? null : schublade.querySelector('[data-kb-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"] [data-kb-' + art + ']');
      if (!ziel || ziel.disabled) ziel = schublade.querySelector('.kb-zu');
      if (ziel) ziel.focus();
    }).catch(function () {});
  }

  /* ---------- Schublade auf und zu ---------- */
  var vorher = null;
  function auf() {
    if (!schublade) return;
    vorher = document.activeElement;
    document.body.classList.add('kb-auf');
    schublade.setAttribute('aria-hidden', 'false');
    var schirm = document.querySelector('.kb-schirm');
    if (schirm) schirm.hidden = false;
    var zu1 = schublade.querySelector('.kb-zu');
    if (zu1) zu1.focus();
  }
  function zu() {
    if (!schublade) return;
    document.body.classList.remove('kb-auf');
    schublade.setAttribute('aria-hidden', 'true');
    var schirm = document.querySelector('.kb-schirm');
    if (schirm) setTimeout(function () { schirm.hidden = true; }, 340);
    if (vorher && vorher.focus) vorher.focus();
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-korb-zu]') : null;
    if (t) { e.preventDefault(); zu(); return; }
    var s = e.target.closest ? e.target.closest('[data-kb-plus], [data-kb-minus], [data-kb-weg]') : null;
    if (s && schublade && schublade.contains(s)) { e.preventDefault(); aendere(s); return; }
    var a = e.target.closest ? e.target.closest('[data-korb-auf]') : null;
    if (a) { e.preventDefault(); letzteNeu = null; hole().then(function (k) { fuelle(k, null); auf(); }); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') zu(); });

  function hole() {
    return fetch(((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||"/")+"cart.js", {headers: {'Accept': 'application/json'}}).then(function (r) { return r.json(); });
  }

  /* Die Produktseite und die Konto-Seite feuern dieses Ereignis, nachdem
     /cart/add.js zurueckgekommen ist. detail.neu = Varianten-IDs. */
  document.addEventListener('materea:korb', function (e) {
    var ids = ((e.detail && e.detail.neu) || []).map(String);
    letzteNeu = ids;
    hole().then(function (k) { fuelle(k, ids); auf(); });
  });

  /* ---------- Seite /cart ---------- */
  var form = document.querySelector('[data-warenkorb]');
  if (form) {
    /* Einmal nachrechnen: wer ohne JavaScript die Menge geaendert hat (die
       Stepper sind dann normale Submit-Knoepfe), hat eine Zulage, die nicht
       mehr zur Gebindezahl passt. Das wird hier geradegezogen. */
    hole().then(function (korb) {
      kopfZahl(korb);
      var updates = {}, schief = false;
      form.querySelectorAll('[data-zulage-fuer]').forEach(function (z) {
        var mkey = z.getAttribute('data-zulage-fuer');
        var mat = form.querySelector('.wk-pos[data-key="' + (window.CSS && CSS.escape ? CSS.escape(mkey) : mkey) + '"]');
        var feld = mat && mat.querySelector('[data-menge]');
        if (!feld) return;
        var soll = parseInt(feld.value, 10) || 1;
        (korb.items || []).forEach(function (i) {
          if (i.key === z.getAttribute('data-key') && i.quantity !== soll) {
            updates[i.key] = soll; schief = true;
          }
        });
      });
      if (schief) {
        fetch(((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||"/")+"cart/update.js", {method: 'POST', headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({updates: updates})}).then(function () { window.location.reload(); });
      }
    });

    function zulageKey(key) {
      var z = form.querySelector('[data-zulage-fuer="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
      return z ? z.getAttribute('data-key') : null;
    }

    /* Die Zulage haengt an ihrem Gebinde. Aendert sich die Menge des
       Materials, muss sie mitgehen, sonst zahlt der Kunde drei getoente
       Gebinde und zwei Zulagen. Deshalb update.js mit beiden Zeilen. */
    function schreibe(key, menge, knopf) {
      if (knopf) knopf.disabled = true;
      var updates = {};
      updates[key] = menge;
      var zk = zulageKey(key);
      if (zk) updates[zk] = menge;
      return fetch(((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||"/")+"cart/update.js", {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({updates: updates})
      }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      }).then(function (k) {
        if (k.item_count === 0) { window.location.reload(); return; }
        zeichne(k);
      }).catch(function () { window.location.reload(); });
    }

    /* Nach einer Aenderung stimmen Zeilensumme, Zulage und Kasse wieder,
       ohne die Seite neu zu laden. Verschwindet eine Zeile, laedt die Seite. */
    function zeichne(korb) {
      var gesehen = {};
      var material = 0, workshop = 0, hatMaterial = false;
      (korb.items || []).forEach(function (z) {
        gesehen[z.key] = z;
        if (istWs(z)) workshop += z.final_line_price;
        else { material += z.final_line_price; if (!istZulage(z)) hatMaterial = true; }
      });
      var fehlt = false;
      form.querySelectorAll('[data-key]').forEach(function (el) {
        var z = gesehen[el.getAttribute('data-key')];
        if (!z) { fehlt = true; return; }
        var s = el.querySelector('[data-zeilensumme]');
        if (s) s.textContent = geld(z.final_line_price);
        var zs = el.querySelector('[data-zulagensumme]');
        if (zs) zs.textContent = geld(z.final_line_price);
        var zm = el.querySelector('[data-zulage-menge]');
        if (zm) zm.textContent = z.quantity;
        var feld = el.querySelector('[data-menge]');
        if (feld) feld.value = z.quantity;
        var minus = el.querySelector('[data-minus]');
        if (minus) { minus.disabled = z.quantity <= 1; minus.value = Math.max(1, z.quantity - 1); }
        var plus = el.querySelector('[data-plus]');
        if (plus) plus.value = z.quantity + 1;
      });
      if (fehlt) { window.location.reload(); return; }
      var mm = form.querySelector('[data-summe-material]');
      if (mm && FREI && hatMaterial) mm.textContent = geld(material);
      var ww = form.querySelector('[data-summe-workshop]');
      if (ww) ww.textContent = geld(workshop);
      var gg = form.querySelector('[data-summe-gesamt]');
      if (gg && (FREI || !hatMaterial)) gg.textContent = geld(korb.total_price);
      kopfZahl(korb);
    }

    form.addEventListener('click', function (e) {
      var knopf = e.target.closest('[data-plus], [data-minus]');
      if (knopf) {
        var zeile = knopf.closest('[data-key]');
        var feld = zeile.querySelector('[data-menge]');
        var n = (parseInt(feld.value, 10) || 1) + (knopf.hasAttribute('data-plus') ? 1 : -1);
        if (n < 1) return;
        e.preventDefault();
        feld.value = n;
        schreibe(zeile.getAttribute('data-key'), n, knopf).then(function () { knopf.disabled = false; });
        return;
      }
      var weg = e.target.closest('[data-entfernen]');
      if (weg) {
        e.preventDefault();
        var z2 = weg.closest('[data-key]');
        schreibe(z2.getAttribute('data-key'), 0, null);
      }
    });

    form.addEventListener('change', function (e) {
      var feld = e.target.closest('[data-menge]');
      if (!feld) return;
      var zeile = feld.closest('[data-key]');
      var n = parseInt(feld.value, 10);
      if (!n || n < 1) { n = 1; feld.value = 1; }
      schreibe(zeile.getAttribute('data-key'), n, null);
    });
  } else {
    hole().then(kopfZahl);
  }
})();
